import { basePathCurrentEnv } from './basePathCurrentEnv.utils';

export function redirectTo(page: string) {
  location.href = `${basePathCurrentEnv()}${page}`;
}
